import React from 'react';
import Icon from '../../../../components/AppIcon';
import { computeDelta, formatDelta, getDeltaToneClasses } from './analysisCompareUtils';

const ScenarioDeltaBadge = ({
  valueA,
  valueB,
  higherIsBetter = true,
  format = 'currency',
  formatCurrency,
  size = 'md',
  showArrow = true,
  className = '',
}) => {
  const { delta, deltaPct, tone } = computeDelta(valueA, valueB, higherIsBetter);
  const classes = getDeltaToneClasses(tone);
  const label = formatDelta(delta, deltaPct, format, formatCurrency);

  const sizeClasses = size === 'sm'
    ? 'text-xs px-2 py-0.5'
    : 'text-sm px-3 py-1';

  const arrow = delta > 0 ? 'TrendingUp' : delta < 0 ? 'TrendingDown' : 'Minus';

  return (
    <span
      data-testid="scenario-delta-badge"
      className={`inline-flex items-center gap-1 rounded-full border font-semibold tabular-nums ${sizeClasses} ${classes.text} ${classes.bg} ${classes.border} ${className}`}
      style={{ fontFamily: 'var(--font-data)' }}
    >
      {showArrow && tone !== 'neutral' && (
        <Icon name={arrow} size={size === 'sm' ? 12 : 14} />
      )}
      {label}
    </span>
  );
};

export default ScenarioDeltaBadge;


